export default __webpack_public_path__ + "static/media/Slider-1.4ddb4174.png";